module.exports = __webpack_public_path__ + "static/assets/3aa6c6bac36d0bc86fbc48b99e86b7fa.svg";